export enum EnumTipoImpressao {
    VENDA = 1,
    TICKET = 2,
    PAGAMENTO = 3,
    PARCELAS = 4,
}